import type {
  SystemStyleInterpolation,
  SystemStyleObject,
} from "@chakra-ui/theme-tools"
import { sizesOptions } from "../common/sizeOptions"
import { Input } from "./input"

const baseStyle: SystemStyleObject = {
  ...Input.baseStyle.field,
  textAlign: "center",
}

const sizes: Record<string, SystemStyleObject> = {
  lg: {
    ...sizesOptions.lg,
    w: sizesOptions.lg.h,
    px: 0,
  },
  md: {
    ...sizesOptions.md,
    w: sizesOptions.md.h,
    px: 0,
  },
  sm: {
    ...sizesOptions.sm,
    w: sizesOptions.sm.h,
    px: 0,
  },
  xs: {
    ...sizesOptions.xs,
    w: sizesOptions.xs.h,
    px: 0,
    _placeholder: {
      fontSize: '2xs',
      transform: 'translateY(-1.5px)',
    }
  },
}

const variants: Record<string, SystemStyleInterpolation> = {
  outline: (props) => Input.variants.outline(props).field ?? {},
  flushed: (props) => Input.variants.flushed(props).field ?? {},
  filled: (props) => Input.variants.filled(props).field ?? {},
  unstyled: Input.variants.unstyled.field ?? {},
}

const defaultProps = {
  ...Input.defaultProps,
  variant: 'outline',
}

export const PinInput = {
  baseStyle,
  sizes,
  variants,
  defaultProps,
}